import { Grid } from "antd";
import { Link } from "react-router-dom";
import React from "react";

const { useBreakpoint } = Grid;

export const Logo = (props) => {

  const breakpoints = useBreakpoint();

  return (
    <div>
      <Link to="/" style={{ display: "flex", alignItems: 'center' }}>
        <span
          className="d-flex align-items-center"
          style={{ color: "white", marginRight: "5px" }}
        >
          <img src="/imgs/ArborSlogan.svg" alt="logo" style={{ width: "90px" }} />
        </span>
      </Link>
    </div>
  );
};

export default Logo;
